export const roomTariffColumns = [
  { Header: 'Sl. No.', accessor: 'Sl' }, 
  { Header: 'Room Type', accessor: 'RoomType' },
  { Header: 'No. of Rooms', accessor: 'NoOfRooms' },
  { Header: 'Price Per Day', accessor: 'PricePerDay' },
  { Header: 'Extra Person Rate', accessor: 'ExtraPersonRate' },
  { Header: 'Effective From', accessor: 'EffectiveFromDate' },
  { Header: 'Effective Till', accessor: 'EffectiveTillDate' },
  { Header: 'Actions', accessor: 'actions' }
];;